import React, { useEffect } from 'react';
const pixelId = '928953936232723';
type PixelFunction = {
  (...args: unknown[]): void;
  queue: unknown[][];
  loaded: boolean;
  version: string;
  push: PixelFunction;
  callMethod?: PixelFunction;
};
declare global {
  interface Window {
    fbq?: PixelFunction;
    _fbq?: PixelFunction;
  }
}
export function MetaPixel() {
  useEffect(() => {
    // Deferred to idle time so tracking never competes with the first paint.
    const start = () => {
      try {
        if (typeof window === 'undefined' || window.fbq) return;
        const fbq = ((...args: unknown[]) => {
          if (fbq.callMethod) {
            fbq.callMethod(...args);
          } else {
            fbq.queue.push(args);
          }
        }) as PixelFunction;
        fbq.queue = [];
        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = '2.0';
        window.fbq = fbq;
        window._fbq = fbq;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head?.appendChild(script);
        fbq('init', pixelId);
        fbq('track', 'PageView');
      } catch {
        // Tracking must never prevent the landing page from rendering.
      }
    };
    const idle = window.requestIdleCallback;
    if (typeof idle === 'function') {
      const handle = idle(start, {
        timeout: 2500
      });
      return () => window.cancelIdleCallback?.(handle);
    }
    const timer = window.setTimeout(start, 1200);
    return () => window.clearTimeout(timer);
  }, []);
  return <noscript data-id="element-82" data-mp="214p1k2euvff7">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`} alt="" data-id="element-83" data-mp="213470csjjwhc" />
    </noscript>;
}